import script from "./UploadModuleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadModuleModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadModuleModal.vue?vue&type=style&index=0&id=826826da&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-826826da"]])

export default __exports__